import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import DatabaseContainer from '../../components/Database/components/Container';

var DatabaseEditorBlock =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DatabaseEditorBlock, _React$Component);

  function DatabaseEditorBlock(props, context) {
    var _this;

    _classCallCheck(this, DatabaseEditorBlock);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatabaseEditorBlock).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hasError: false
    });

    _this.SyncedDatabaseContainer = _this.props.provideDatabaseSync(DatabaseContainer);
    return _this;
  }

  _createClass(DatabaseEditorBlock, [{
    key: "componentDidCatch",
    value: function componentDidCatch() {
      this.setState({
        hasError: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Database is now handling it focus
      if (!prevProps.isFocused && this.props.isFocused || !prevProps.isSelected && this.props.isSelected) {
        this.props.editor.blur();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return React.createElement("div", {
          className: "background-white center-text shade-10 border-small border-shade-40 radius-normal padding-medium"
        }, '🙅‍ This database has encountered an issue.');
      }

      var databaseNoteId = this.props.node.data.get('databaseNoteId');
      var readOnly = this.props.editor.readOnly;
      var currentUserId = this.props.currentUserId;
      var _this$props = this.props,
          fetchNotes = _this$props.fetchNotes,
          fetchUsers = _this$props.fetchUsers,
          getUser = _this$props.getUser,
          makeNoteLinkPlugin = _this$props.makeNoteLinkPlugin,
          setActiveModal = _this$props.setActiveModal;
      return React.createElement("div", this.props.attributes, React.createElement(this.SyncedDatabaseContainer, {
        databaseNoteId: databaseNoteId,
        currentUserId: currentUserId,
        readOnly: readOnly,
        fetchNotes: fetchNotes,
        fetchUsers: fetchUsers,
        getUser: getUser,
        makeNoteLinkPlugin: makeNoteLinkPlugin,
        setActiveModal: setActiveModal
      }));
    }
  }]);

  return DatabaseEditorBlock;
}(React.Component);

export default DatabaseEditorBlock;